import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import qs from 'qs';
import { withRouter } from 'react-router-dom';
import { formValueSelector } from 'redux-form';
import { Row, Col } from '@saucelabs/sl-component-grid';
import { FormAlert } from '@saucelabs/sl-component-form';
import { apiBaseUrls, MULTI_DC_SUPPORT, DEFAULT_DC, CURRENT_DC } from '@saucelabs/sl-util-config';
import { operations as authOperations } from '@saucelabs/sl-container-authentication';

import { operations, types } from './../ducks';
import FormTitle from './../components/FormTitle';
import HelpLinks from './../components/HelpLinks';
import LoginForm from './../components/LoginForm';
import FormWrapper from './../components/FormWrapper';
import ScreenerBanner from './../images/screener.png';
import Styles from './LoginContainer.styles';

class LoginContainer extends Component {
  componentDidMount() {
    window.addEventListener('beforeunload', authOperations.resetInfoAboutInactivityLogout);
  }

  componentWillUnmount() {
    authOperations.resetInfoAboutInactivityLogout();
    window.removeEventListener('beforeunload', authOperations.resetInfoAboutInactivityLogout);
  }

  render() {
    const {
      currentDataCenter,
      errorMessage,
      infoMessage,
      loginUser,
      nextQueryParam,
      successMessage,
      warningMessage,
    } = this.props;

    const renderGithubLogin = () => {
      if (!MULTI_DC_SUPPORT || currentDataCenter === DEFAULT_DC) {
        return (
          <div>
            {'GitHub user? '}
            <a href="https://saucelabs.com/oauth/login/github">
              Login with your GitHub account
            </a>
          </div>
        );
      }

      return (
        <div>
          {`Login with GitHub is currently supported only in '${DEFAULT_DC}' DC`}
        </div>
      );
    };

    return (
      <Row between="xs">
        <Col
          lg={6}
          md={8}
          xs={12}
        >
          <FormWrapper>
            <Helmet>
              <title>Login</title>
            </Helmet>
            <FormTitle>Sign In</FormTitle>
            <FormAlert type="success">{successMessage}</FormAlert>
            <FormAlert type="danger">{errorMessage}</FormAlert>
            <FormAlert type="warning">{warningMessage}</FormAlert>
            <FormAlert type="info">{infoMessage}</FormAlert>
            <LoginForm
              loginUser={loginUser}
              nextQueryParam={nextQueryParam}
            />
            <HelpLinks>
              <div>
                {'New to Sauce Labs? '}
                <a href={apiBaseUrls.signup}>
                  Create an Account
                </a>
              </div>
              {renderGithubLogin()}
              <br />
              <div>
                <strong>Real Device Cloud (formerly TestObject)</strong>
                <br />
                {'Looking for the Real Device Cloud? '}
                <a href="https://app.testobject.com/#/login/">
                  Log in here
                </a>
              </div>
            </HelpLinks>
          </FormWrapper>
        </Col>
        <Col
          className={Styles['banner-wrapper']}
          lg={5}
          md={4}
          xs={12}
        >
          <a
            href="https://screener.io/?utm_source=sauce&utm_medium=login"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              alt="Screener Logo"
              className={Styles.banner}
              src={ScreenerBanner}
            />
          </a>
        </Col>
      </Row>
    );
  }
}


const mapStateToProps = (store, { location: { search, state } }) => {
  const queryParams = qs.parse(search, { ignoreQueryPrefix: true });
  const currentDataCenter = formValueSelector(types.LOGIN_FORM)(store, 'data_center') || CURRENT_DC;
  const multiDCLoginWarning = 'To log into two different data centers you will need to use two separate browser sessions';
  const inactivityLogoutInfo = 'You have been logged out due to inactivity';

  return {
    nextQueryParam: queryParams.next || queryParams.redirect_to || '/dashboard',
    successMessage: state && state.success,
    errorMessage: state && state.error,
    warningMessage: (state && state.warning) ||
     (MULTI_DC_SUPPORT && !state ? multiDCLoginWarning : null),
    infoMessage: authOperations.showInfoAboutInactivityLogout() ? inactivityLogoutInfo : null,
    currentDataCenter,
  };
};

const mapDispatchToProps = {
  loginUser: operations.login,
};

LoginContainer.propTypes = {
  currentDataCenter: PropTypes.string,
  errorMessage: PropTypes.string,
  infoMessage: PropTypes.string,
  loginUser: PropTypes.func.isRequired,
  nextQueryParam: PropTypes.string,
  successMessage: PropTypes.string,
  warningMessage: PropTypes.string,
};

LoginContainer.defaultProps = {
  currentDataCenter: null,
  errorMessage: null,
  infoMessage: null,
  nextQueryParam: null,
  successMessage: null,
  warningMessage: null,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginContainer));
export { LoginContainer, mapDispatchToProps };
